import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ManagerApproval,
  Operation,
  OperationApproval,
  OperationCards,
  OperationDissaproval,
  OperationsDetail,
  OperationSearchParams,
  OperationStatus,
  UpdateStatus,
} from '../../models/operation.model';
import { ApiResponse, DefaultResponse } from '../../models';
import { HistoryEvent } from '../../models/history-events.model';
import {
  BatchDisposalsPaged,
  FilterBatchDisposals,
} from '../../models/batch-disposals.model';
import { OperationsPayment } from '../../models/operations-payment.model';

@Injectable({
  providedIn: 'root',
})
export class OperationService {
  private readonly API = `${environment.api_url}/operation`;

  constructor(private http: HttpClient) {}

  getAll(
    filters: OperationSearchParams
  ): Observable<DefaultResponse<Operation>> {
    return this.http.post<DefaultResponse<Operation>>(
      `${this.API}/GetOperations`,
      filters
    );
  }

  getStatus(): Observable<ApiResponse<OperationStatus[]>> {
    return this.http.get<ApiResponse<OperationStatus[]>>(
      `${environment.api_url}/StatusOperacao`
    );
  }

  updateOperation(body: UpdateStatus): Observable<void> {
    return this.http.post<void>(`${this.API}/status/update`, body, {
      responseType: 'text' as 'json',
    });
  }

  getDetailsById(operationId: number): Observable<OperationsDetail> {
    return this.http.get<OperationsDetail>(
      `${this.API}/details/${operationId}`
    );
  }

  getOperationReportById(operationId: number): Observable<string> {
    return this.http.get<string>(
      `${environment.api_url}/relatorios/cessao/${operationId}/pdf`,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          responseType: 'blob',
        }),
        responseType: 'blob' as 'json',
      }
    );
  }

  consultancyApproval(body: OperationApproval): Observable<void> {
    return this.http.post<void>(`${this.API}/approval/consultancy`, body);
  }

  consultancyDissaproval(body: OperationDissaproval): Observable<void> {
    return this.http.post<void>(`${this.API}/dissaproval/consultancy`, body);
  }

  managerApproval(body: ManagerApproval): Observable<void> {
    return this.http.post<void>(`${this.API}/approval/manager`, body);
  }

  managerDissaproval(body: OperationDissaproval): Observable<void> {
    return this.http.post<void>(`${this.API}/dissaproval/manager`, body);
  }

  getValueCards(data: Date): Observable<OperationCards> {
    const params = new HttpParams().set(
      'dataInicio',
      data.toISOString().split('T')[0]
    );
    return this.http.post<OperationCards>(
      `${this.API}/GetCardsOperation`,
      null,
      {
        params: params,
      }
    );
  }

  resendOperation(idOperacao: number): Observable<void> {
    return this.http.post<void>(
      `${environment.api_url}/CallBack/Send/${idOperacao}`,
      null
    );
  }

  getHistoryOperation(idOperation: number): Observable<HistoryEvent> {
    return this.http.get<HistoryEvent>(
      `${this.API}/historicoOperacao/${idOperation}`
    );
  }

  sendBatchDisposals(body: FormData): Observable<any> {
    return this.http.post<any>(`${this.API}/BaixasEmLote`, body);
  }

  operationsPayment(): Observable<OperationsPayment[]> {
    return this.http.get<OperationsPayment[]>(`${this.API}/operations-payment`);
  }

  listDisposalsBatchFiles(filter): Observable<BatchDisposalsPaged> {
    console.log('Filter:', filter);
    return this.http.post<BatchDisposalsPaged>(
      `${this.API}/FilterBaixasLote`,
      {
        dataImportacao: filter.dataImportacao.toISOString(),
        nomeFundo: filter.nomeFundo,
      },
      {
        params: {
          pageNumber: filter.pageNumber,
          pageSize: filter.pageSize,
        },
      }
    );
  }

  deleteMovementById(idArquivo: number): Observable<void> {
    return this.http.delete<void>(
      `${this.API}/ExcluirMovimentosPorIdArquivo/${idArquivo}`
    );
  }
}
